import { Autocomplete, Stack, TextField } from "@mui/material";
import React from "react";
import { languageOptions, renderComBrandOption, comBrandOptions } from "../_Utils/AppDocuCommon";

/**
 * ResourceDialogForm - Form for Add/Edit Resource
 * Same as DocumentDialogForm but with 'folder' instead of 'document_type'
 */
export default function ResourceDialogForm({ itemData, onChange, disabled, hideOriginalFilename }) {
  return (
    <Stack spacing={2}>
      {!hideOriginalFilename && (
        <TextField fullWidth label="File Name" value={itemData.original_filename || ''} onChange={e => onChange({ ...itemData, original_filename: e.target.value })} disabled={disabled} />
      )}
      <TextField fullWidth label="Name" value={itemData.name || ''} onChange={e => onChange({ ...itemData, name: e.target.value })} disabled={disabled} />
      <Autocomplete
        freeSolo
        fullWidth
        options={comBrandOptions.map(opt => opt.name)}
        value={itemData.com_brand || ''}
        onChange={(_, newValue) => onChange({ ...itemData, com_brand: newValue || '' })}
        onInputChange={(_, newInputValue) => onChange({ ...itemData, com_brand: newInputValue })}
        renderOption={renderComBrandOption}
        renderInput={(params) => <TextField {...params} label="Com Brand" disabled={disabled} />}
        disableClearable
        autoHighlight
      />
      <TextField
        fullWidth
        label="Folder"
        value={itemData.folder || ''}
        onChange={e => onChange({ ...itemData, folder: e.target.value })}
        disabled={disabled}
        placeholder="es: Manuali/Landi/DI60"
        helperText="Percorso per organizzare ad albero (es: Manuali/Landi/DI60)"
      />
      <TextField
        fullWidth
        label="Description"
        value={itemData.description || ''}
        onChange={e => onChange({ ...itemData, description: e.target.value })}
        multiline
        minRows={3}
        disabled={disabled}
      />
      <Autocomplete
        freeSolo
        fullWidth
        options={languageOptions}
        value={itemData.language || ''}
        onChange={(_, newValue) => onChange({ ...itemData, language: newValue || '' })}
        onInputChange={(_, newInputValue) => onChange({ ...itemData, language: newInputValue })}
        renderInput={(params) => <TextField {...params} label="Language" disabled={disabled} />}
        disableClearable
        autoHighlight
      />
    </Stack>
  );
}
